
  export const style={
    inpuStyle:{
      colorInput:"#3E6323"
    },
    url:{
      urlClient:"https://bambuibio.prd.appnoz.com.br/",
      urlClientYouseed:"https://admyouseed.bancosemear.com.br/"
    },
    fileUrl:{
      logo:"https://timcoo-geral.s3.us-east-1.amazonaws.com/Logos/primary_logo_client_bambui.png",
      secondaryLogonLogo: "null",
    },
    variables:{
       customMenuItem: true,
       autoRegister: false,
       recaptchaVersion : "V2"
    },
    CurrencyName:{
      name:"bbiu/bbius"
    },
    teamName:{
      name:"Bambuibio"
    },
    hasToken: false,
    hostHeader: "bambuibio"
  }
